import { combineReducers } from "redux"
import {reducer as fromReducer } from 'redux-form'
import {reducer as toastrReducer} from 'react-redux-toastr'

import DashboardReducer from "../dashboard/dashboardReducer"
import TabReducer from "../common/tab/tabReducer"
import UsuarioReducer from '../usuario/usuarioReducer'
import AuthReducer from '../auth/authReducer'
import UnidadeReducer from '../unidade/unidadeReducer'
import BoletoReducer from '../boleto/boletoReducer'
import CarneReducer from '../carne/carneReducer'
import RotinaAutomaticaReducer from "../rotinaautomatica/rotina_automaticaReducer"
import configuracaoReducer from "../configuracoes/configuracaoReducer"

const rootReducer = combineReducers({
    dashboard: DashboardReducer,
    tab:TabReducer,
    usuario : UsuarioReducer,
    unidade:UnidadeReducer,
    boleto:BoletoReducer,
    carne : CarneReducer,
    form: fromReducer,
    toastr : toastrReducer,
    auth : AuthReducer, 
    rotina_automatica : RotinaAutomaticaReducer,
    configuracao: configuracaoReducer
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/main/reducers.js